export const environment = {
	production: false,
	baseUrl: 'https://azureapi-dev.arrowxl.co.uk/v1/',
	username: 'qateamdev',
	password: '#f6hhsjeFv6I)DyxHKg9buM4JY##jY@wGBMY'
};
